<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody">
          <div class="topList">
              <div class="leftSwiper">
                    <swiper ref="mySwiper" :options="swiperOptions">
                        <swiper-slide class="slide-1" v-for="(item,index) in swipList" :key="index">
                            <div :style="{backgroundImage:'url('+item.cover+')'}" class="fullBG" @click="gotoPage(item.link)"></div>
                        </swiper-slide>

                        <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                    </swiper>
              </div>
              <div class="rightList">
                  <div class="rightListTitle betweenTitle">
                      <div>{{$t("newsVal")}}</div>
                      <div class="linkMoreFontClass" @click="linkToNewsList()">{{$t("moreVal")}}</div>
                    </div>
                  <div class="rightSwiperList">
                      <!-- titleSwiperOptions -->
                        <swiper ref="mySwiperNews" :options="titleSwiperOptions">
                            <swiper-slide class="slide-11" v-for="(item,indexNews) in newListTitles" :key="indexNews">
                                <router-link class="titleListClass" :to="{path:'/newsDetail',query:{id:itemnew.id}}" v-for="(itemnew,indexx) in item" :key="indexx" >{{itemnew.title}}</router-link>
                                <!-- <div class="titleListClass"  v-for="(itemnew,indexx) in item" :key="indexx" @click="gotoNewsPage(itemnew.id)">{{itemnew.title}}</div> -->
                            </swiper-slide>

                            <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                        </swiper>
                  </div>
                  <!-- <div class="titleListClass"  v-for="(item,indexs) in titleList" :key="indexs" @click="gotoNewsPage(item.id)">{{item.title}}</div> -->
                  <!-- <Page @on-change="changePageFN" class="rightListPage" :page-size="7" :current="currentPage" :total="titleTotal" simple /> -->
              </div>
          </div>
          <div class="rightListInner">
                <div class="rightListTitle betweenTitle">
                    <div>{{$t("newsVal")}}</div>
                    <div class="linkMoreFontClass" @click="linkToNewsList()">{{$t("moreVal")}}</div>
                </div>
                <swiper ref="mySwiperNewsMobile" :options="titleSwiperOptionsMobile">
                    <swiper-slide class="slide-1" v-for="(item,indexNews) in newListTitles" :key="indexNews">
                        <router-link class="titleListClass" :to="{path:'/newsDetail',query:{id:itemnew.id}}" v-for="(itemnew,indexx) in item" :key="indexx" >{{itemnew.title}}</router-link>

                        <!-- <div class="titleListClass"  v-for="(itemnew,indexx) in item" :key="indexx" @click="gotoNewsPage(itemnew.id)">{{itemnew.title}}</div> -->
                    </swiper-slide>

                    <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                </swiper>
                <!-- <div class="titleListClass"  v-for="(item,indexs) in titleList" :key="indexs" @click="gotoNewsPage(item.id)">{{item.title}}</div>
                <Page @on-change="changePageFN" class="rightListPage" :page-size="5" :current="currentPage" :total="titleTotal" simple /> -->
            </div>
          <div class="first_floor">
              <div class="floorTitle floorBGClass firstImg">
                  <div>{{swipNewsFirstList.title}}</div>
                  <div class="linkMoreClass" @click="linkToDetail(1)">{{$t("moreVal")}}</div>
              </div>
              <div class="first_floor_swiper">
                  <swiper ref="mySwiperNewsLatest" :options="swiperOptions_news">
                      <!-- v-if="pcPhone" -->
                      <swiper-slide v-if="pcPhone" class="slidesNews specialSwiper showHideSwiper">

                        <div class="swiperInner">
                            <div class="heightBorder"></div>
                            <div class="fullBig bigBackOne"  @mouseleave="hideTitleFN" @mouseenter="showTitleFN" @click="gotoModelPage(swipNewsFirstList.top.id,swipNewsFirstList.top.contentType)" :style="{backgroundImage:'url('+swipNewsFirstList.top.cover+')'}">
                                <div class="innerShow" style="padding:0 30px">
                                    <div class="titleNameInner">{{swipNewsFirstList.top.title}}</div>
                                    <div class="titleContentInner">{{swipNewsFirstList.top.introduction}}</div>

                                </div>
                            </div>
                            <!-- <div class="bgTitle">
                                <marquee vspace="0" behavior="alternate" scrolldelay="200" onmouseover="this.stop();" onmouseout="this.start();">
                                    {{swipNewsFirstList.top.title}}
                                </marquee>
                            </div> -->

                            <div class="bgTitle" :title="swipNewsFirstList.top.title">{{swipNewsFirstList.top.title}}</div>
                        </div>

                    </swiper-slide>
                    <swiper-slide class="slidesNews"  v-for="(item,index) in swipNewsFirstList.programs" :key="index">

                        <div class="swiperInner" >
                            <div class="overShowSize">
                                <div class="heightBorder"></div>
                                <div class="halfPic halfTwice" @click="gotoModelPage(item[0].id,item[0].contentType)" :style="{backgroundImage:'url('+item[0].cover+')'}">
                                    <div class="innerShow">
                                        <div class="titleNameInner">{{item[0].title}}</div>
                                        <div class="titleContentInner">{{item[0].introduction}}</div>
                                    </div>
                                </div>
                                <div class="bgTitle bgTwice" :title="item[0].title">{{item[0].title}}</div>
                            </div>

                            <div class="midHeight"></div>
                            <div  class="overShowSize">
                                <div class="halfPic halfTwice" v-if="item[1]" @click="gotoModelPage(item[1].id,item[1].contentType)" :style="{backgroundImage:'url('+item[1].cover+')'}">
                                    <div class="innerShow">
                                        <div class="titleNameInner">{{item[1].title}}</div>
                                        <div class="titleContentInner">{{item[1].introduction}}</div>
                                    </div>
                                </div>

                                <div class="bgTitle bgTwice" v-if="item[1]" :title="item[1].title">{{item[1].title}}</div>
                            </div>

                        </div>

                    </swiper-slide>
                    <swiper-slide class="slidesNews"  >

                        <div class="swiperInner" >

                        </div>

                    </swiper-slide>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                </swiper>
              </div>
          </div>
          <div class="paddingHeight"></div>
          <div class="second_floor" v-for="(items,indexList) in swipNewsListRest" :key="indexList">
              <div class="floorTitle floorBGClass otherImg">
                  <div>{{items.title}}</div>
                  <div class="linkMoreClass" @click="linkToDetail(items.contentType,items.id)">{{$t("moreVal")}}</div>

              </div>
              <div class="second_floor_swiper">
                  <swiper :ref="'mySwiperSec_'+indexList" :options="swiperOptions_sec">
                    <swiper-slide class="slidesNews"  v-for="(item,indexInner) in items.programs" :key="indexInner">
                        <div class="swiperInner scaleClass">
                            <div class="otherMarginClass"></div>
                            <div class="bg_title" @click="gotoModelPage(item.id,item.contentType)" :style="{backgroundImage:'url('+item.cover+')'}"></div>
                            <div class="middleMark"></div>
                            <!-- <div class="bgTitle" >
                                <marquee vspace="0" behavior="alternate" scrolldelay="200" onmouseover="this.stop();" onmouseout="this.start();">
                                    {{item.title}}
                                </marquee>
                            </div> -->

                            <div class="bgTitle titleHeight" :title="item.title">{{item.title}}</div>
                        </div>

                    </swiper-slide>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                  </swiper>
              </div>
          </div>
          <!-- <div class="floating-window">
            <img onclick="window.location.href='http://sstvf.webxun.com:100/';"
              style="width: 200px; height: 100px"
              src="../assets/popModel.jpg"></img>
            <div style="width:100%;text-align:center;" onclick="window.location.href='http://sstvf.webxun.com:100/';">我要参加</div>
          </div> -->
          <!-- <div class="paddingHeight_1"></div> -->
      </div>      
      <div class="homeBottom">
            <div class="partnerList">
              <div class="partneListTitle">{{$t("partnerVal")}}</div>
              <div class="partnerListContent">
                  <div  v-for="(item,indexpartner) in partnerList" :key="indexpartner" @click="gotoPage(item.link)" :style="{backgroundImage:'url(' + item.logo + ')'}" class="partnerImg"></div>
                    <div class="logoMark"></div>
                    <div class="logoMark"></div>
                    <div class="logoMark"></div>
                    <div class="logoMark"></div>
                    <div class="logoMark"></div>
                    <div class="logoMark"></div>
              </div>
            </div>
      </div>
      <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
// import imageBg from '../assets/bg.png'
// import imageSmallBg from '../assets/2.png'
import { advertisementRequest, newsRequest, homePageRequest, parnerRequest, newsDetailRequest } from '../request/request'
let vm = null
export default {
  name: 'home',
  components: {
    headerShow, footerView
  },
  data () {
    return {
      imgUrl: '../assets/popModel.jpg',
      heightMark: '0',
      newListTitles: [],
      languageVal: 'ch',
      currentPage: 1,
      partnerList: [],
      swipNewsList: [],
      swipList: [{ cover: '' }],
      titleList: [],
      swipNewsFirstList: { top: { cover: '' }, programs: [{ cover: '' }, { cover: '' }] },
      swipNewsListRest: [{ programs: [{ cover: '' }] }],
      titleTotal: 0,
      pcPhone: true,
      titleSwiperOptions: {
        spaceBetween: 30,
        effect: 'flip',
        loop: true,
        initialSlide: 2,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        //   effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      titleSwiperOptionsMobile: {
        spaceBetween: 30,
        effect: 'flip',
        loop: true,
        initialSlide: 0,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        //   effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOptions: {
        initialSlide: 0,
        spaceBetween: 30,
        // effect: 'flip',
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        //   effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptions_news: {
        // slidesPerView: 'auto',
        slidesPerView: 2,
        spaceBetween: 10,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50
          },
          1920: {
            slidesPerView: 6,
            spaceBetween: 50
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptions_sec: {
        slidesPerView: 2,
        spaceBetween: 10,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50
          },
          1920: {
            slidesPerView: 6,
            spaceBetween: 50
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiperNews.$swiper
    },
    mobileswiper () {
      return this.$refs.mySwiperNewsMobile.$swiper
    }
  },
  mounted () {
    if (document.body.clientWidth < 700) {
      this.pcPhone = false
    } else {
      this.pcPhone = true
    }
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
    //   console.log('Current Swiper instance object', this.swiper)
    //   this.swiper.slideTo(3, 1000, false)
  },
  created () {
    vm = this
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  methods: {
   
    async newsDetailRequestFN (e) {
      var res = await newsDetailRequest(e)
      if (res.data.code === 0) {
      }
    },
    async advertisementRequestFN (e) {
      var res = await advertisementRequest(e)
      if (res.data.code === 0) {
        this.swipList = res.data.data
      }
    },
    async newsRequestFN (e) {
      var res = await newsRequest(e)
      if (res.data.code === 0) {
        // PC
        if (e.blurMark === 1) {
          this.newListTitles = this.group(res.data.data.news, 7)
        } else {
          this.newListTitles = this.group(res.data.data.news, 5)
        }
        this.$nextTick(() => {
          this.swiper.slideTo(1, 100, false)
          this.mobileswiper.slideTo(1, 100, false)
        })

        this.titleList = res.data.data.news
        this.titleTotal = res.data.data.totalNumber
      }
    },
    async homePageRequestFN (e) {
      var res = await homePageRequest(e)
      if (res.data.code === 0) {
        var listArr = res.data.data[0].programs

        if (document.body.clientWidth < 700) {
        //   listArr.unshift(res.data.data[0].top)
        }
        let len = listArr.length
        let n = 2
        let lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1)
        let result = []
        for (let i = 0; i < lineNum; i++) {
          let temp = listArr.slice(i * n, i * n + n)
          result.push(temp)
        }
        res.data.data[0].programs = result
        var middleSwip = JSON.parse(JSON.stringify(res.data.data[0]))
        middleSwip.programs = this.group(res.data.data[0].programs, 2)
        this.swipNewsFirstList = res.data.data[0]// this.group(res.data.data[0], 2)
        console.log(res.data.data[0])
        console.log(this.swipNewsFirstList)
        res.data.data.splice(0, 1)
        this.swipNewsListRest = res.data.data
      }
    },
    async parnerRequestFN (e) {
      var res = await parnerRequest(e)
      if (res.data.code === 0) {
        this.partnerList = res.data.data
      }
    },

    showTitleFN () {
      debugger
      this.heightMark = '1'
    },

    hideTitleFN () {
      this.heightMark = '0'
    },

    linkToNewsList () {
      this.$router.push({
        path: '/newsList',
        name: 'newsList'

      })
    },

    gotoModelPage (e, type) {
      if (type == 1) {
        this.$router.push({
          path: '/patternDetail',
          name: 'patternDetail',
          query: {
            id: e
          }
        })
      }
      if (type == 2) {
        this.$router.push({
          path: '/newsDetail',
          name: 'newsDetail',
          query: {
            id: e
          }
        })
      }
      if (type == 3) {
        this.$router.push({
          path: '/costum',
          name: 'costum',
          query: {
            id: e
          }
        })
      }
    },

    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },

    gotoNewsPage (e) {
      debugger
      this.$router.push({
        path: '/newsDetail',
        name: 'newsDetail',
        query: {
          id: e

        }
      })
    //   this.newsDetailRequestFN({ id: e })
    },
    linkToDetail (e, id) {
      if (e && e == 3) {
        localStorage.reportListPage = '1'
        this.$router.push({
          path: `/reportList`,
          query: {
            contentType: e,
            id: id
          }
        })
      } else if (e && e == 4) {
        localStorage.smgListPage = '1'
        this.$router.push({
          path: `/smgDetail`
        })
      } else {
        localStorage.detailPage = '1'
        this.$router.push({
          path: `/detail`
        })
      }
    },

    gotoPage (e) {
      window.open(e)
    },

    initFN () {
      let lanVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
      this.advertisementRequestFN({ offset: 6, lang: lanVal })
      var pageSize = 25
      var blurMark = 0
      if (document.body.clientWidth > 700) {
        pageSize = 35
        blurMark = 1
      }
      this.newsRequestFN({ lang: lanVal, pageNum: 1, size: pageSize, blurMark: blurMark })
      this.homePageRequestFN({ lang: lanVal })
      this.parnerRequestFN({ offset: 16 })
    },

    changePageFN (e) {
      let lanVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
      var pageSize = 25
      if (document.body.clientWidth > 700) {
        pageSize = 35
      }
      this.newsRequestFN({ lang: lanVal, pageNum: e, size: pageSize })
    },

    group (array, subGroupLength) {
      let index = 0
      let newArray = []
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength))
      }
      return newArray
    }

  }
}
</script>
<style lang="scss">
.floating-window {
  position: fixed;
  bottom: 50px;
  right: 20px;
  z-index: 10; /* 确保悬浮窗体在其他内容之上 */
  background-color: white;
  // padding: 20px;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 10px rgba(0,0,0,.5);
}

.titleContentInner{
    margin-top: 5px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    text-align: left;
}
.specialSwiper .titleContentInner{
    -webkit-line-clamp: 7;
}
.specialSwiper .titleNameInner{
    font-size: 14px;
    padding-left: 20px;
}
.titleNameInner{
    padding:0 5px;
    font-weight: bold;
    text-align: left;
}
.innerShow{
    height: 0%;
    overflow: hidden;
    width: 100%;
    padding: 0 10px;
    background: rgba($color: #fff, $alpha: 1);
    font-size:11px !important;
    transition: all 1s;
}
.halfTwice{
    height: 80% !important;
}
.bgTwice{
    height: 20% !important;
}
.overShowSize{
    height: 49.5%;
    width: 100%;
}
.rightSwiperList{
    height: 85%;
    width: 100%;
}
.rightListInner{
    overflow: hidden;
}
.rightListInner .swiper-slide{
    // background-color:#DBEEFF ;
}
.rightSwiperList .swiper-slide{
    // background-color:#DBEEFF ;
}
.betweenTitle{
    justify-content: space-between !important;
}
.linkMoreFontClass{
    color: #000;
    cursor: pointer;
    font-size: 13px;
}
.linkMoreFontClass:hover{
        color: #40A0F0;
}
.otherMarginClass{
    height: 6%;
}
.second_floor_swiper .titleHeight{
    height: 14%;
}
.swiperInner .bigBackOne,.halfTwice{
    height: 84%;
    @include bottomLine;
    align-items: flex-end;
    overflow: hidden;
}
.heightBorder{
    height: 5%;
}
.specialSwiper{
    width: 30vw !important;
}
.first_floor_swiper .slidesNews{

}
.logoMark{
    width: 130px;
    height: 0px;
    margin: 15px;
}
.floorBGClass{
    padding-left:6vh;
    @include containbackground;
    background-position:left
}
.floorTitle{
    margin:0.4vh 0
}
.firstImg{
    background-image: url('../assets/first.png');
}
.otherImg{
    background-image: url('../assets/other.png');
}
.fullBig{
    background-size:cover
}
.halfPic{
    background-size:100% 100%
}
.bg_title{
    background-size:cover
}
.rightListInner{
    display: none;
}
.rightListPage{
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
    pointer-events:auto
}
.swiper-button-prev, .swiper-button-next{
    border-radius: 50%;
    background:#DCEBEE
}
.swiper-button-prev, .swiper-button-next{
    width:var(--swiper-navigation-size) !important
}
.swiper-button-prev:after, .swiper-button-next:after{
    font-size:calc( var(--swiper-navigation-size) / 2) !important;
    font-weight:bolder
}
.swiper-button-prev.swiper-button-white, .swiper-button-next.swiper-button-white{
    --swiper-navigation-color:#40A0F0 !important
}
.home .swiper-pagination-bullet-active{
    background-color: #40A0F0 !important;
    width: 26px !important;
    opacity:1 !important;
    margin: 0 -2px !important;
    margin-bottom: 8px !important
}
.home .swiper-pagination-bullet {
    width: 21px;
    height: 3px;
    display: inline-block;
    border-radius: 2px;
    background: #000;
    opacity: 0.2;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
        margin: 0 1px;
}
.first_floor,.paddingHeight,.second_floor,.homeBody{
    background: #EFF6FD;
}
.fullBG{

    @include fullbackground
}
.paddingHeight{
    height: 6.7vh;
}
.paddingHeight_1{
    height: 11vh;
}
.middleMark{
    // height: 5%;
}
.midHeight{
    height: 1%;
}
.swiperInner{
    width: 100%;
    height: 100%;
}
.halfPic{
     width: 100%;
    height: 37%;
}
.fullBig{
    width: 100%;
    height: 90%;
}
.bgTitle{
    cursor: pointer;
    margin-top: 3px;
    display: block;
    text-align: center;
    font-size: 13px;
    height:8%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.footerSec{
    color:#979797;
    font-size: 12px;
    width:370px;
    margin:0 auto;
    margin-top: 2vh;
    @include betweenLine
}
.footerVal{
    @include centerLine;
    color:#979797;
    font-size: 12px;
}
.footeritem{
    width: 80px;

    border-right: 1px solid #979797;
}
.homeFooter{
    width: 100%;
    height: 25.5vh;
    border-top:2px solid #40A0F0;
    @include formCenter
}
.swiper-container{
    height:100%
}
.first_floor_swiper{
    height:36.4vh
}
.second_floor_swiper{
    height:22vh
}
.bg_title{
    height:80%
}
.overShowSize:hover .bgTitle{
    visibility: hidden;
}
.overShowSize:hover .innerShow{
    height: 80%;
}
.showHideSwiper:hover .bgTitle{
    visibility: hidden;
}
.showHideSwiper:hover .innerShow{
    height: 80%;
}
.specialSwiper:hover .swiper-container{
    padding-left: 26px;
}
.specialSwiper:hover{
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
}
// .fullBig:hover{
//      transform: scale(1.15);
//     -webkit-transform: scale(1.15);
//     -moz-transform: scale(1.15);
//     -ms-transform: scale(1.15);
//     -o-transform: scale(1.15);
// }
.overShowSize:hover{
    transform: scale(1.15);
    -webkit-transform: scale(1.15);
    -moz-transform: scale(1.15);
    -ms-transform: scale(1.15);
    -o-transform: scale(1.15);
}
.scaleClass:hover{
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
}
.partnerImg{
    @include containbackground;
    width: 130px;
    height: 90px;
    margin: 15px;
    cursor: pointer;
    // background-image: url('../assets/3.png');
}
.partnerImg:hover{
    border: 1px solid #40A0F0;
}
.home{
    width:100%;
    .header{
      background: #ffffff;
      height: 7vh;
      min-height: 60px;
      padding: 0 0px;
      @include betweenLine;
      color: white;
    }
    .floorTitle{
        @include betweenLine;
        height:5vh;
        &>div{
            height: 100%;
            @include centerLine
        }
        .linkMoreClass{
            font-size: 12px;
            cursor:pointer;
        }
        .linkMoreClass:hover{
            color:#40A0F0
        }
    }
    .first_floor{
        height: 41.4vh;
        width:90%;
        margin: 0 auto
    }
    .second_floor{
        height: 30.5vh;
        width:90%;
        margin: 0 auto;
        padding-bottom: 5.5vh;
    }
    .homeBody{
        width: 100%;
        .topList{
            position: relative;
            padding: 0;
            width: 100%;
            height:25.33vw;
            margin-bottom:5vh;
            @include centerLine;
            .swiper-slide{
                background-position: center;
                background-size: cover;
            }
            .leftSwiper{
                width: 76vw;
                // width: 100vw;
                height:100%
            }
            .rightList{
                overflow:auto;
                width: 24vw;
                height:100%;
                background:#DBEEFF;
                padding:1% 2%;
                position:relative;
                .rightListTitle{
                    @include startLine;
                    height: 10%;
                    font-size: 21px;
                    margin-bottom:1%;
                    color: #40A0F0;
                    border-bottom: 2px solid #40A0F0;
                }
                .betweenTitle{
                    justify-content: space-between !important;
                }
                .linkMoreFontClass{
                    color: #000;
                    cursor: pointer;
                    font-size: 13px;
                }
                .linkMoreFontClass:hover{
                     color: #40A0F0;
                }
                .titleListClass{
                    display: block;
                    color: #000;
                    text-align: left;
                    cursor: pointer;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-top: 3%;
                }
                .titleListClass:hover{
                    color:#40A0F0
                }
            }
        }
    }
    .homeBottom{
        width:100%;
        .partnerList{
            font-size: 4vh;
            width: 100%;
            @include centerLine;
            flex-direction: column;
            .partneListTitle{
                margin-top: 3vh;
                margin-bottom:3vh;
                border-bottom:2px solid #2E6DAD
            }
            .partnerListContent{
                @include startLine;
                justify-content: center;
                flex-wrap: wrap;
                width:80%;
                margin: 0 auto;
            }
        }
    }
    .ivu-modal-header{
        background: #2E6DAD
    }
}

</style>
